import { React, useState, useEffect, useContext, useRef } from 'react';
import * as utils from "../utils.js";

const Undo_Redo = (params, ref) => {
    const { maxHistory = 10, onChange, onInit } = params;
    const [data, setData] = useState([]);
    const [index, setIndex] = useState(null);

    useEffect(() => {
        //console.log(`The actual index of undo_redo is ${index} of ${data.length - 1}`);
    }, [index]);

    if (onInit) {
        onInit({
            push: (item) => {
                return _push(item);
            }
        });
    }


    const _push = (item) => {
        if (data.length > 0) {
            const _last = data[data.length - 1];
            if (JSON.stringify(_last) == JSON.stringify(item)) return;
        }

        while (data.length > maxHistory - 1) {
            data.splice(0, 1);
        }

        data.push(utils.clone(item));
        setIndex(data.length - 1);
    }

    const _undo = () => {
        if (index > 0) {
            setIndex(index - 1);
            return data[index - 1];
        }
        else {
            return null;
        }
    }

    const _redo = () => {
        if (index != null && index < data.length - 1) {
            setIndex(index + 1);
            return data[index + 1];
        }
        else {
            return null;
        }
    }

    return (
        <>
            <a className={(index == null || index == 0) ? "me-2 position-relative disabled fs-13" : "me-2 position-relative text-primary fs-13"} href="#" disabled={(index == null || index == 0)}
                onClick={(e) => {
                    if (index > 0) {
                        if (onChange) onChange(_undo());
                    }                    
                }}
                title="undo last action"
            >
                {index > 0 ? index : ""}
                <i className="fa-solid fa-rotate-left fa-2x"></i>

            </a>
            &nbsp;
            <a href="#" className={(index == null || index == data.length - 1) ? "me-3 position-relative disabled fs-13" : "position-relative me-3 text-primary fs-13"} disabled={(index == null || index == data.length - 1)}
                onClick={(e) => {
                    if (onChange && index != null && index != data.length - 1) onChange(_redo());
                }}
                title="redo last action"
            ><i className="fa-solid fa-rotate-right fa-2x"></i> {data.length - index - 1 > 0 ? data.length - index - 1 : ""}</a>            
        </>
    )
};

export default Undo_Redo 